var agendaJs = (function () {
  function init() {
    uiBindings();
  }

  var uiBindings = function () {

    var agendaDayNavMob = document.querySelectorAll('.agendaDayNavMob');

    //set mobile days
    if (window.innerWidth < 640) {
      for (var index = 0; index < agendaDayNavMob.length; index++) {
        var element = agendaDayNavMob[index],
        elementLink = element.querySelectorAll(".agenda--day-link-el"),
        elementH3 = element.querySelectorAll(".is-active-day-el");

        element.classList.add("agenda--days");

        for (var index2 = 0; index2 < elementLink.length; index2++) {
          if (elementLink[index2]) {
            elementLink[index2].classList.add("agenda--day-link");
          }
        }

        for (var index3 = 0; index3 < elementLink.length; index3++) {
          if (elementH3[index3]) {
            elementH3[index3].classList.add("agenda--day");
          }
        }      
      }
    } else if (agendaDayNavMob.length > 0) {
      for (var index = 0; index < agendaDayNavMob.length; index++) {
        var element = agendaDayNavMob[index];
        if (element) {
          element.remove();
        }
      }
    }

    var dayTriggerBtns = document.querySelectorAll('.agenda--day-link'),
    dayHeaders = document.querySelectorAll('.agenda--session-container'),
    agendaDayNav = document.getElementById('agendaDayNav'),
    agendaContent = document.getElementById("agendaContent"),
    headerHabitat = document.getElementById("header-habitat");
    
    if (dayTriggerBtns) {
      dayTriggerBtns.forEach(function(dayTriggerBtns, index) {
        dayTriggerBtns.addEventListener('click', function(e) {
          e.preventDefault();

          var that = this, currentTabData = document.querySelector('.agenda--session[data-tab-content="' + this.dataset.tabTrigger + '"]'),
          offsetTop = document.querySelector(that.getAttribute("href")).offsetTop + agendaContent.offsetTop - headerHabitat.offsetHeight - (window.innerWidth < 640 ? 42: 0);

          //Remove class
          document.querySelector('.agenda--session.is-open').classList.remove('is-open');
          document.querySelector('.agenda--day.is-active').classList.remove('is-active');
          
          //Add Class
          currentTabData.classList.add('is-open');
          that.querySelector('.agenda--day').classList.add('is-active');
          
          //Scroll Day Content position
          bsLib.scrollIt(
            offsetTop,
            500
          );
        });
      });
    }

    //Agenda Scroll feature
    function agendaCurrentPosition() {
      var offsetTop = agendaContent.offsetTop - headerHabitat.offsetHeight,
      offsetBottom = agendaContent.offsetTop + agendaContent.offsetHeight;

      if (window.scrollY >= offsetTop && window.scrollY <= offsetBottom) {
        agendaContent.classList.add('is-active');
      } else {
        agendaContent.classList.remove('is-active');
      }

      offsetBottom = agendaContent.offsetTop + agendaContent.offsetHeight - agendaDayNav.offsetHeight - 134;

      if (window.scrollY >= offsetBottom) {
        agendaContent.classList.add('is-active-bottom');
      } else {
        agendaContent.classList.remove('is-active-bottom');
      }

      //Set active Day on scroll
      dayTriggerBtns.forEach(function(link) {
        var section = document.querySelector(link.hash),
        fromTop = window.scrollY + headerHabitat.offsetHeight + (window.innerWidth >= 980
          ? 21 : 10);

        if ( section &&
          section.offsetTop + agendaContent.offsetTop <= fromTop &&
          section.offsetTop + agendaContent.offsetTop + section.offsetHeight > fromTop
        ) {
          //remove class
          document.querySelector('.agenda--day.is-active').classList.remove("is-active");

          //check class and add class
          if (!section.classList.contains("is-open")) {
            document.querySelector('.agenda--session.is-open').classList.remove('is-open');
            section.classList.add('is-open');
          }
          link.querySelector('.agenda--day').classList.add("is-active");
        } else {
          link.querySelector('.agenda--day').classList.remove("is-active");
        }

        //default (Assign to first child active class)
        if (!document.querySelector('.agenda--day.is-active')) {
          document.querySelector('.agenda--day').classList.add("is-active");
        }
      });

      dayHeaders.forEach(function(section) {
        var fromTop = window.scrollY + headerHabitat.offsetHeight + (section.classList.contains("agenda--session-container--last") ? (window.innerWidth >= 980
          ? 0 : -10): (window.innerWidth >= 980
          ? 21 : 10)),
        agendaSessionOpen = document.querySelector('.agenda--session.is-open');
        
        //remove sticky class
        if (section.classList.contains("sticky")) {
          section.classList.remove("sticky");
        }
        
        //check current section
        if ( !(agendaSessionOpen && agendaSessionOpen.contains(section))) {
          return;
        }
        
        if ( agendaSessionOpen.offsetTop + agendaContent.offsetTop <= fromTop &&
          agendaSessionOpen.offsetTop + agendaContent.offsetTop + agendaSessionOpen.offsetHeight - (section.classList.contains("agenda--session-container--last") ? 96: 0) > fromTop
        ) {
          if (!section.classList.contains("sticky")) {
            section.classList.add("sticky");
          }
          if (section.classList.contains("bottom-sticky")) {
            section.classList.remove("bottom-sticky");
          }
        } else if (agendaSessionOpen.offsetTop + agendaContent.offsetTop <= fromTop && section.classList.contains("agenda--session-container--last")) {
          if (!section.classList.contains("bottom-sticky")) {
            section.classList.add("bottom-sticky");
          }
          if (section.classList.contains("sticky")) {
            section.classList.remove("sticky");         
          } 
        } 
      });

      //
      sessionDates = document.querySelectorAll('.agenda--session.is-open .agenda--session-date');
      sessionDates.forEach(function(section, index) {
        var agendaSessionOpen = document.querySelector('.agenda--session.is-open'),
        agendaMainTime = agendaSessionOpen.querySelector(".agenda--main-time"),
        secBounding = section.getBoundingClientRect(),
        mainBounding = agendaMainTime.getBoundingClientRect(),
        mainTimer = agendaMainTime.querySelector(".agenda--main-timer"),
        nextTimer = agendaMainTime.querySelector(".agenda--next-timer");

        if (mainBounding.top >= secBounding.top) {
          if (section.classList.contains("active")) {
            section.classList.remove("active");
          }
        } else {
          if (!section.classList.contains("active")) {
            section.classList.add("active");
          }
        }

        //for last session
        if (agendaSessionOpen.querySelectorAll(".agenda--session-date.active").length === 0 && index === sessionDates.length - 1) {
          mainTimer.classList.add("hide");
          nextTimer.classList.remove("hide");
          nextTimer.innerHTML = section.textContent;
        }

        //check section condition
        if ( mainBounding.top > secBounding.top || window.scrollY < agendaContent.offsetTop || agendaSessionOpen.querySelector(".agenda--session-date.active") !== section) {
          return;
        }
        
        //for first session
        if (index == 0) {
          mainTimer.classList.remove("hide");
          nextTimer.classList.add("hide");
        } else if (index > 0) {
          mainTimer.classList.add("hide");
          nextTimer.classList.remove("hide");
          nextTimer.innerHTML = sessionDates[index - 1].textContent;
        }
        
      });
    }

    function agendaCurrentPosition640() {
      var offsetTop = agendaContent.offsetTop - headerHabitat.offsetHeight,
      offsetBottom = agendaContent.offsetTop + agendaContent.offsetHeight;

      if (window.scrollY >= offsetTop && window.scrollY <= offsetBottom) {
        agendaContent.classList.add('is-active');
      } else {
        agendaContent.classList.remove('is-active');
      }

      offsetBottom = agendaContent.offsetTop + agendaContent.offsetHeight - agendaDayNav.offsetHeight - 134;

      //Set active Day on scroll
      dayTriggerBtns.forEach(function(link) {
        var section = document.querySelector(link.hash),
        fromTop = window.scrollY + headerHabitat.offsetHeight + 52;

        if ( section &&
          section.offsetTop + agendaContent.offsetTop <= fromTop &&
          section.offsetTop + agendaContent.offsetTop + section.offsetHeight > fromTop
        ) {
          //remove class
          document.querySelector('.agenda--day.is-active').classList.remove("is-active");

          //check class and add class
          if (!section.classList.contains("is-open")) {
            document.querySelector('.agenda--session.is-open').classList.remove('is-open');
            section.classList.add('is-open');
          }
          link.querySelector('.agenda--day').classList.add("is-active");
        } else {
          link.querySelector('.agenda--day').classList.remove("is-active");
        }

        //default (Assign to first child active class)
        if (!document.querySelector('.agenda--day.is-active')) {
          document.querySelector('.agenda--day').classList.add("is-active");
        }
      });

      dayHeaders.forEach(function(section) {
        var fromTop = window.scrollY + headerHabitat.offsetHeight,
        agendaSessionOpen = document.querySelector('.agenda--session.is-open');
        
        //remove sticky class
        if (section.classList.contains("sticky")) {
          section.classList.remove("sticky");
        }
        
        //check current section
        if ( !(agendaSessionOpen && agendaSessionOpen.contains(section))) {
          return;
        }

        // console.log(agendaSessionOpen.offsetTop + agendaContent.offsetTop <= fromTop);
        
        if ( agendaContent.offsetTop + 21 <= fromTop &&
          agendaContent.offsetTop + agendaContent.offsetHeight - 150 > fromTop
        ) {
          if (!section.classList.contains("sticky")) {
            section.classList.add("sticky");
          }
          if (section.classList.contains("bottom-sticky")) {
            section.classList.remove("bottom-sticky");
          }
        } else if (agendaContent.offsetTop + agendaContent.offsetHeight - 150 <= fromTop && section.classList.contains("agenda--session-container--last")) {
          if (!section.classList.contains("bottom-sticky")) {
            section.classList.add("bottom-sticky");
          }
          if (section.classList.contains("sticky")) {
            section.classList.remove("sticky");         
          } 
        }
      });

      //
      sessionDates = document.querySelectorAll('.agenda--session.is-open .agenda--session-date');
      sessionDates.forEach(function(section, index) {
        var agendaSessionOpen = document.querySelector('.agenda--session.is-open'),
        agendaMainTime = agendaSessionOpen.querySelector(".agenda--main-time"),
        secBounding = section.getBoundingClientRect(),
        mainBounding = agendaMainTime.getBoundingClientRect(),
        mainTimer = agendaMainTime.querySelector(".agenda--main-timer"),
        nextTimer = agendaMainTime.querySelector(".agenda--next-timer");

        if (mainBounding.top >= secBounding.top) {
          if (section.classList.contains("active")) {
            section.classList.remove("active");
          }
        } else {
          if (!section.classList.contains("active")) {
            section.classList.add("active");
          }
        }

        //for last session
        if (agendaSessionOpen.querySelectorAll(".agenda--session-date.active").length === 0 && index === sessionDates.length - 1) {
          mainTimer.classList.add("hide");
          nextTimer.classList.remove("hide");
          nextTimer.innerHTML = section.textContent;
        }

        //check section condition
        if ( mainBounding.top > secBounding.top || window.scrollY < agendaContent.offsetTop || agendaSessionOpen.querySelector(".agenda--session-date.active") !== section) {
          return;
        }
        
        //for first session
        if (index == 0) {
          mainTimer.classList.remove("hide");
          nextTimer.classList.add("hide");
        } else if (index > 0) {
          mainTimer.classList.add("hide");
          nextTimer.classList.remove("hide");
          nextTimer.innerHTML = sessionDates[index - 1].textContent;
        }
        
      });
    }

    //width
    if (window.innerWidth < 640) {
      window.addEventListener("load", agendaCurrentPosition640);
      window.addEventListener("resize", agendaCurrentPosition640);
      window.addEventListener("scroll", agendaCurrentPosition640);
    } else {
      window.addEventListener("load", agendaCurrentPosition);
      window.addEventListener("resize", agendaCurrentPosition);
      window.addEventListener("scroll", agendaCurrentPosition);  
    }
    
  };

  init();
})();